var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hero)?_c('div',[_c('img',{attrs:{"src":_vm.getHeroSrc(),"alt":_vm.hero}}),(_vm.isRandom)?_c('random-sign'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }